/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__DescriptionInputs */

const en_help_center__bidding_n_battles__description = /** @type {(inputs: Help_Center__Bidding_N_Battles__DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understand bidding strategies, battle types, and how to win`)
};

/**
* | output |
* | --- |
* | "Understand bidding strategies, battle types, and how to win" |
*
* @param {Help_Center__Bidding_N_Battles__DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__description = /** @type {((inputs?: Help_Center__Bidding_N_Battles__DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__description(inputs)
});